import { Component, Injector } from '@angular/core';
import { appearance } from '../../../../config/appearance';
import { CanvasLayoutDataService } from '../../../../submodules/angular-common/canvas-layout-data.service';
import { MenuNode } from '../../../../submodules/angular-ui-common/base-types';
import { SecurityDataService } from '../../../angular-common/security-data.service';
import { BaseView } from '../../base-view';
import { EnvironmentDataService } from 'src/app/submodules/angular-common/environment-data.service';

export interface MenuSettings {
  nodes?: MenuNode[]
}

@Component({
  selector: 'app-private-area-canvas',
  templateUrl: './private-area-canvas.component.html',
  styleUrls: ['./private-area-canvas.component.scss']
})
export class PrivateAreaCanvasComponent extends BaseView {

  menuTreeSettings: MenuSettings;

  private trigger; 

  constructor(
    public securityDataService: SecurityDataService,
    public canvasLayoutDataService: CanvasLayoutDataService,
    protected _injector: Injector
  ) {
    super(_injector);
    this._injector.get(CanvasLayoutDataService).headerHeight = appearance.privateArea.header.height;
    this._injector.get(CanvasLayoutDataService).bgUrl = appearance.privateArea.bgUrl;
    this._injector.get(CanvasLayoutDataService).bgColor = appearance.privateArea.bgColor;
  }

  async ngOnInit() {
    if(this._injector.get(EnvironmentDataService).environment.getValue("attendanceMarkingEnabled")==true){
      console.log('attendanceMarkingEnabled false:>> ');
      await this._injector.get(SecurityDataService).keepSessionAliveAndMarkAttendance();

      this.trigger = setInterval(async ()=>{
        await this._injector.get(SecurityDataService).keepSessionAliveAndMarkAttendance()
      },(this._injector.get(EnvironmentDataService).environment.getValue("sessionKeepAliveIntervalInSec"))*1000)
     
    }else{
      console.log('attendanceMarkingEnabled true:>> ');
      await this._injector.get(SecurityDataService).keepSessionAlive();

      this.trigger = setInterval(async ()=>{
        await this._injector.get(SecurityDataService).keepSessionAlive()
      },(this._injector.get(EnvironmentDataService).environment.getValue("sessionKeepAliveIntervalInSec"))*1000)
    }
  }

  ngAfterViewInit(): void {
    // se c'è abbastanza spazio ed è un menu laterale ad albero, allora apre automaticamente la sidenav
    if(appearance.privateArea.menu && appearance.privateArea.menu.show && !this.isXxxs)
        this._injector.get(CanvasLayoutDataService).openSidenav1()
  }

  ngOnDestroy(){
    clearInterval(this.trigger);
  }
}
